import { c as _c } from "react/compiler-runtime";
import { CMSImage, CMSLink, CMSText } from "@/modules/cms/components/cms-items";
import type { HeaderConfigType, ImageTextItem } from "@/modules/cms/schema";
export const ImageTextItemRenderer = t0 => {
  const $ = _c(33);
  const {
    item,
    layoutType,
    onClick
  } = t0;
  const itemText = item.text;
  if (layoutType === "smallImageLeftRight") {
    let t1;
    if ($[0] !== item.image) {
      t1 = item.image && <CMSImage image={item.image} width={60} height={60} className="h-[60px] w-[60px] shrink-0 object-contain" priority={true} />;
      $[0] = item.image;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== itemText) {
      t2 = <div className="w-[150px] overflow-hidden whitespace-nowrap text-ellipsis"><CMSText text={itemText} /></div>;
      $[2] = itemText;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== onClick || $[5] !== t1 || $[6] !== t2) {
      t3 = <div onClick={onClick} className="bg-[#f5f5f5] flex h-full w-full flex-row flex-nowrap items-center justify-start gap-3">{t1}{t2}</div>;
      $[4] = onClick;
      $[5] = t1;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== item.link || $[9] !== t3) {
      t4 = <CMSLink link={item.link} className="my-1 flex h-[72px] w-[240px] flex-row flex-nowrap items-center justify-start gap-3   text-lg hover:cursor-pointer hover:text-[#d2001e]">{t3}</CMSLink>;
      $[8] = item.link;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  if (layoutType === "mediumImageTopBottom") {
    let t1;
    if ($[11] !== item.image) {
      t1 = item.image && <CMSImage image={item.image} width={120} height={120} className="mb-2 h-auto  object-contain" priority={true} />;
      $[11] = item.image;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    let t2;
    if ($[13] !== itemText) {
      t2 = <div className="w-[120px] overflow-hidden whitespace-nowrap text-ellipsis text-center"><CMSText text={itemText} /></div>;
      $[13] = itemText;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    let t3;
    if ($[15] !== onClick || $[16] !== t1 || $[17] !== t2) {
      t3 = <div onClick={onClick} className="flex flex-col items-center justify-center space-y-1">{t1}{t2}</div>;
      $[15] = onClick;
      $[16] = t1;
      $[17] = t2;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    let t4;
    if ($[19] !== item.link || $[20] !== t3) {
      t4 = <CMSLink link={item.link} className="flex flex-col items-center justify-center space-y-1 leading-none no-underline transition-colors outline-none hover:text-[#d2001e]">{t3}</CMSLink>;
      $[19] = item.link;
      $[20] = t3;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    return t4;
  }
  if (layoutType === "largeImageTopBottom") {
    let t1;
    if ($[22] !== item.image) {
      t1 = item.image && <CMSImage image={item.image} width={360} height={150} className="mb-2 h-[150px] w-[360px] object-contain" priority={true} />;
      $[22] = item.image;
      $[23] = t1;
    } else {
      t1 = $[23];
    }
    let t2;
    if ($[24] !== itemText) {
      t2 = <div className="w-[360px] overflow-hidden whitespace-nowrap text-ellipsis"><CMSText text={itemText} /></div>;
      $[24] = itemText;
      $[25] = t2;
    } else {
      t2 = $[25];
    }
    let t3;
    if ($[26] !== onClick || $[27] !== t1 || $[28] !== t2) {
      t3 = <div onClick={onClick} className="flex flex-col items-start justify-center space-y-1">{t1}{t2}</div>;
      $[26] = onClick;
      $[27] = t1;
      $[28] = t2;
      $[29] = t3;
    } else {
      t3 = $[29];
    }
    let t4;
    if ($[30] !== item.link || $[31] !== t3) {
      t4 = <CMSLink link={item.link} className="flex flex-col items-start justify-center space-y-1 leading-none no-underline transition-colors outline-none hover:text-[#d2001e]">{t3}</CMSLink>;
      $[30] = item.link;
      $[31] = t3;
      $[32] = t4;
    } else {
      t4 = $[32];
    }
    return t4;
  }
  return null;
};